module.exports = require("./../../_gen/starling/text/TrueTypeCompositor");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/text/TrueTypeCompositor.js
// module id = 232
// module chunks = 0